import { type NonCoreMetadata } from '@core/database/interfaces/database.interface'
import { type UseCase } from '@core/referential/use-case.enum'
import { isEmpty } from 'lodash-es'
import { twMerge } from 'tailwind-merge'

import { useAuth } from '@/hooks/use-auth'

export function cn(...inputs: Parameters<typeof twMerge>) {
  const classes = twMerge(inputs)

  if (classes === '') return undefined

  return classes
}

// Normalise une chaîne pour la recherche : supprime les accents et les caractères
// invisibles (largeur nulle, marques directionnelles, BOM), ramène les espaces
// Unicode (insécables, fines, etc.) à un espace simple et passe en minuscules.
// Aligné sur cleanStringSchema (back) pour matcher aussi les données déjà stockées « sales ».
export function normalizeForSearch(value: string) {
  return value
    .normalize('NFKD')
    .replaceAll(/[̀-ͯ]/g, '')
    .replaceAll(/[​-‏­⁠﻿]/g, '')
    .replaceAll(/\s+/g, ' ')
    .trim()
    .toLowerCase()
}

// Recherche insensible aux accents, à la casse et aux espaces Unicode.
// Renvoie true si `search` est contenu dans `value` une fois les deux normalisés.
export function searchIncludes(value: string | null | undefined, search: string) {
  if (!search) return true

  return normalizeForSearch(value ?? '').includes(normalizeForSearch(search))
}

export function isUseCase(useCase: UseCase) {
  const { user } = useAuth.getState()

  return user?.currentUseCase === useCase
}

export function isOffline(nonCoreMetadata: NonCoreMetadata | undefined | null) {
  return (
    nonCoreMetadata?.cloudConnectorConnectionStatus === 'OFFLINE' ||
    isEmpty(nonCoreMetadata) ||
    nonCoreMetadata?.sensorSignalStrengh === 0 ||
    nonCoreMetadata?.cloudConnectorCellularSignalStrength === 0
  )
}
